import { Skeleton } from "@mui/material";
import {
  BlockCard,
  DonutChartSkeleton,
  SelectPillSkeleton,
} from "../primitives";
import styles from "./style.module.scss";

interface ReadingMixBlockSkeletonProps {
  count?: number;
  className?: string;
}

function ReadingMixBlockSkeleton({
  count = 5,
  className,
}: ReadingMixBlockSkeletonProps) {
  return (
    <BlockCard
      title={<Skeleton variant="text" width={120} height={26} />}
      className={className}
      actions={<SelectPillSkeleton width={136} />}
    >
      <div className={styles.body}>
        <DonutChartSkeleton size={150} className={styles.donut} />
        <div className={styles.legend}>
          {Array.from({ length: count }).map((_, index) => (
            <div key={index} className={styles.legendRow}>
              <Skeleton variant="rounded" width={10} height={10} />
              <Skeleton variant="text" width="70%" height={18} />
              <Skeleton variant="text" width={32} height={18} />
              <Skeleton variant="text" width={46} height={16} />
            </div>
          ))}
        </div>
      </div>
    </BlockCard>
  );
}

export default ReadingMixBlockSkeleton;
